import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import moment from 'moment-timezone';

const downloadThis = (d) => {
  axios.post('/request/dataset/dv', {
    studyId: d.studyId,
    reason: d.reason,
  }).then((r) => {
    if (r.data.status) {
      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);
      a.setAttribute(
        'href',
        `/download/dataset/dv/${
          d.studyId
        }/${d.dcaId}/${r.data.dataset_id}/${r.data.downloadToken}`);
      a.setAttribute('target', '_blank');
      a.click();
      document.body.removeChild(a);
      setTimeout(() => {
        d.setLoader(false);
        d.setInfo(false);
        document.querySelector('.popup-header .fa-times').click();
      });
    } else {
      d.setLoader(false);
      d.setInfo(r.data.message);
    }
  });
}

const hasPermission = (permission) => {
  if (permission?.persistentId) {
    return permission.dcaId !== 2 &&
    permission.dcaId !== 4 &&
    permission.dcaId !== 6
    || false;
  }

  return false;
}

const PopupPermission = ({ show }) => {
  const {
    studyID,
    studyTitle,
    studyDetailData
  } = useSelector(s => s.studyDetail);
  const [loader, setLoader] = useState(false);
  const [reason, setReason] = useState('');
  const [accept, setAccept] = useState(false);
  const [permission, setPermission] = useState(false);
  const [info, setInfo] = useState(false);

  const resetStates = () => {
    setPermission(false);
    setLoader(false);
    setInfo(false);
    setReason('');
    setAccept(false);
  };

  useEffect(() => {
    if (show) {
      if (show === 'Permission') {
        setLoader(true);

        /* >> Temporary: handle auto email sender down */
        // if (studyDetailData.dcaId === 3 || studyDetailData.dcaId === 5) {
        //   setInfo('Data is still on progress.');
        //   setLoader(false);
        //   return;
        // }
        /* << Temporary: handle mail sender down */

        if (studyDetailData.persistentId && studyDetailData.dcaId) {
          setPermission({
            persistentId: studyDetailData.persistentId,
            dcaId: studyDetailData.dcaId || null,
            dcaEmbargoExpiryDate: studyDetailData.dcaEmbargoExpiryDate || null,
            dcaUserCaption: studyDetailData.dcaUserCaption
          });
        } else {
          setInfo(
            !studyDetailData.persistentId && studyDetailData.dcaId
              ? 'Data is still on progress.'
              : 'Awaiting permissions.'
          );
        }
        setLoader(false);
      }
    }

    return () => {
      resetStates();
    }
  }, [show])

  if (!show) {
    return null;
  }

  if (
    !permission &&
    !info &&
    show === 'Permission'
  ) {
    return (
      <div className="lds-dual-ring2" />
    );
  }

  const onClickDownload = (event) => {
    event.preventDefault();
    if (accept && reason.trim() !== '') {
      setLoader(true);
      setInfo(false);
      downloadThis({
        reason,
        studyId: studyID,
        dcaId: studyDetailData.dcaId,
        setLoader,
        setInfo,
      });
    } else {
      if (!accept) {
        document.getElementById('accept-block')
          .classList.toggle('is-visible');

        setTimeout(() => {
          document.getElementById('accept-block')
            .classList.toggle('is-visible');
        }, 500);
      }

      if (reason.trim() === '') {
        document.getElementById('reason-block')
          .classList.toggle('is-visible');

        setTimeout(() => {
          document.getElementById('reason-block')
            .classList.toggle('is-visible');
        }, 500);
      }
    }
  };

  return (
    <div
      className="popup-child"
      style={{
        display: `${show === 'Permission' ? '' : 'none'}`,
        opacity: `${show ? 1 : 0}`
      }}
    >
      {
        info && (
          <p className="alert alert-warning" style={{ fontWeight: 400 }}>
            <span style={{
              display: 'table-cell',
              verticalAlign: 'top',
              paddingRight: 8
            }}>
              <i className="fa fa-info-circle"/>
            </span>
            <span style={{ display: 'table-cell', verticalAlign: 'top' }}>
              {info}
            </span>
          </p>
        )
      }
      {
        !info && (
          <form className="popup-child-text">
            <h6 style={{ marginBottom: 15 }}>
              {studyTitle}
            </h6>
            <p
              className="alert alert-warning"
              style={{ fontWeight: 400 }
            }>
              <span style={{
                display: 'table-cell',
                verticalAlign: 'top',
                paddingRight: 8
              }}>
                <i className="fa fa-info-circle"/>
              </span>
              <span style={{
                display: 'table-cell',
                verticalAlign: 'top'
              }}>
                {'Please note: this portal is for downloading individual '}
                {'datasets. If you would like to analyse the whole database '}
                {'then please contact the WILDMEAT team.'}
              </span>
            </p>

            <p dangerouslySetInnerHTML={{
              __html:`${permission.dcaUserCaption}${
                  hasPermission(permission)
                    ? ''
                    : (
                        [
                          ' <strong style="color: #856405;">',
                          moment(
                            permission.dcaEmbargoExpiryDate
                          ).format('Do of MMMM yyyy'),
                          '</strong>'
                        ].join('')
                      )
                } `
            }} />
            {
              hasPermission(permission) && (
                <>
                  <div
                    id="reason-block"
                    className="form-group toggle-content is-visible"
                  >
                    <label htmlFor="reason-for-use">
                      <b style={{
                        fontWeight: 500,
                        color: '#836f35'
                      }}>
                        General reason for use:
                      </b>
                    </label>
                    <input
                      onChange={(event) => {
                        setReason(event.target.value);
                      }}
                      value={reason}
                      type="text"
                      className="form-control"
                      placeholder="Type your reason..."
                      id="reason-for-use"
                      required
                    />
                  </div>

                  <div
                    id="accept-block"
                    className="
                      form-group form-check checkbox toggle-content is-visible
                    "
                  >
                    <input
                      type="checkbox"
                      checked={accept}
                      onChange={(event) => {
                        setAccept(event.target.checked);
                      }}
                      className="form-check-input"
                      id="accept"
                      required
                    />
                    <label
                      className="form-check-label"
                      htmlFor="accept"
                    >
                      I have read and accept the above Terms & Conditions
                    </label>
                  </div>

                  <hr/>

                  <div className="row">
                    <div className="col-sm-6">
                      {
                        loader && show === 'Permission' ? <div className="lds-dual-ring2"></div> : (
                          <button
                            type="submit"
                            disabled={accept ? false : true}
                            className={`btn btn-primary ${accept ? '' : 'btn-disabled'}`}
                            onClick={onClickDownload}
                          >
                            Download
                          </button>
                        )
                      }
                    </div>
                    <div className="col-sm-6 text-right">
                      {
                        loader ? null : (
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={(event) => {
                              event.preventDefault();
                              resetStates();
                              document.querySelector(
                                '.popup-header .fa-times'
                              ).click();
                            }}
                          >
                            Cancel
                          </button>
                        )
                      }
                    </div>
                  </div>
                </>
              )
            }
          </form>
        )
      }
    </div>
  )
};

export default PopupPermission;
